// Australian postcode validation using logic from is-valid-australian-postcode npm package
// https://www.npmjs.com/package/is-valid-australian-postcode
// Browser-compatible implementation to avoid module bundling issues
// reference: https://en.wikipedia.org/wiki/Postcodes_in_Australia


(function() {
    var regExp = /^[0-9]{3,4}$/;


    function isValidAustralianPostcode(rawPostcode) {
        if (!rawPostcode || !regExp.test(rawPostcode.toString())) {
            return false;
        }
        var numPostcode = Number(rawPostcode);
        if (numPostcode < 200 || (numPostcode >= 300 && numPostcode <= 799) || numPostcode > 9999) {
            return false;
        }
        return true;
    }


    // Expose the function globally
    window.isValidAustralianPostcode = isValidAustralianPostcode;
})();